<template>
  <FormHeader
    :primary-color="primaryColor"
    progress="2"
  >
    <template #title>
      <p>
        {{ __('co_reg_lander_002_step_2_text') }}
      </p>
    </template>

    <template #subtext>
      <p>
        {{ __('co_reg_lander_002_step_2_subtext') }}
      </p>
    </template>
  </FormHeader>

  <div class="grid gap-y-6">
    <div class="pb-2">
      <p class="font-bold text-xl pb-4 text-center">
        {{ __('label_email') }}
      </p>

      <input
        v-model="$store.state.form.email"
        name="email"
        class="w-full h-12 border border-gray-300 rounded-md"
        type="email"
        :placeholder="__('placeholder_email')"
        @keydown.enter="submit()"
      >

      <ErrorMessage name="email" />
    </div>
  </div>

  <FormFooter
    step="2"
    :primary-color="primaryColor"
    :button-color="buttonColor"
    :can-submit="canSubmit"
    @submit="submit()"
  />
</template>

<script setup>
import {__, isPreview} from '@timon/js/Mixins/helpers';
import {computed, ref} from 'vue';
import FormHeader from '@timon/js/Templates/CO-REG-LANDER-002/Components/FormHeader.vue';
import FormFooter from '@timon/js/Templates/CO-REG-LANDER-002/Components/FormFooter.vue';
import ErrorMessage from '@timon/js/Components/ErrorMessage.vue';
import {useStore} from 'vuex';

const emit = defineEmits(['submit']);

const props = defineProps({
  config: {
    type: Object,
    required: true,
  },

  canSubmit: {
    type: Boolean,
    required: true,
  },
});

const primaryColor = ref(props.config.style?.primary);
const buttonColor = ref(props.config.style?.buttons);

const store = useStore();

const allFieldsFilled = computed(() => {
  return !!store.state.form.email;
});

const submit = () => {
  store.commit('errors/clearErrors');

  if (isPreview()) {
    emit('submit');
    return;
  }

  if (!props.canSubmit) {
    return;
  }

  if (!allFieldsFilled.value) {
    setRequiredErrors();

    return;
  }

  emit('submit');
};

function setRequiredErrors() {
  if (!store.state.form.email) {
    store.commit('errors/setErrors', {
      'email': [__('validation_field_required').replace(':attribute', __('label_email'))],
    });
  }
}
</script>
